import { AfterViewInit, Component, Input, ViewChild, inject } from '@angular/core';
import { DeliveryCondition, DeliveryConditionsComponent } from '@lib/delivery-conditions';
import { NotificationMessageLevel, NotificationService } from '@lib/core';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { DemandDeliveryConditionDataService } from './demand-delivery-condition-data.service';

@Component({
    selector: 'demand-supplier-delivery-condition',
    templateUrl: './demand-supplier-delivery-condition.component.html',
    styleUrls: ['./demand-supplier-delivery-condition.component.scss'],
    standalone: false
})
export class DemandSupplierDeliveryConditionComponent implements AfterViewInit {
    private readonly deliveryConditionDataService = inject(DemandDeliveryConditionDataService);
    private readonly notificationService = inject(NotificationService);

    @ViewChild(DeliveryConditionsComponent) public selectionComponent!: DeliveryConditionsComponent;

    @Input() public condition?: DeliveryCondition;
    @Input() public supplierCompanyId!: string;
    @Input() public demandId!: string;
    @Input() public editable = false;

    ngAfterViewInit(): void {
        if (!this.condition && this.editable) {
            this.selectionComponent.enableEditing();
        }
    }

    public deleteCurrent(): void {
        if (this.editable && this.condition) {
            this.deliveryConditionDataService.deleteCondition(this.demandId, this.supplierCompanyId).subscribe(() => {
                const message = marker('Lieferbedingung entfernt');
                this.notificationService.showNotification(message, NotificationMessageLevel.SUCCESS);
                this.condition = undefined;
                this.editable ? this.selectionComponent.enableEditing() : this.selectionComponent.disableEditing();
            });
        }
    }

    public update(newCondition: DeliveryCondition): void {
        if (this.editable) {
            this.deliveryConditionDataService
                .updateCondition(this.demandId, this.supplierCompanyId, newCondition.value.id)
                .subscribe(() => {
                    const message = marker('Lieferbedingung gespeichert');
                    this.notificationService.showNotification(message, NotificationMessageLevel.SUCCESS);
                    this.condition = newCondition.value;
                    this.selectionComponent.disableEditing();
                });
        }
    }
}
